export default {"src":"/_next/static/media/web-tools.6a3eb2a8.svg","height":30,"width":30};